import { Component, OnInit } from '@angular/core';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { SmartModalService } from 'src/modules/base/services/smart-modal.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
import { DialogConfig } from '../../dialog/dialog-config';
import { DialogRef } from '../../dialog/dialog-ref';
import { PopupFormComponent } from '../../popupform/popupform.component';

@Component({
    selector: 'app-search-patient',
    templateUrl: './search-patient.component.html',
    styleUrls: ['./search-patient.component.scss'],
    standalone: false
})
export class SearchPatientComponent  implements OnInit {
  clearSearchResult: boolean = true;

  constructor(
    public config: DialogConfig,
    private alerts: AlertsService,
    private rolePermissionService: RolePermissionService,
    private baseService: BaseService,
    private smartModalService: SmartModalService,
    private dialog: DialogRef,
    private loader: LoaderService,
    private appService: AppService,
    private sessioNStorage: StorageService
  ) { }

  ngOnInit() {
    console.log("this['data']", this.config.data);
  }

  settingUserInfo(item) {
    if (this.config.data.hasOwnProperty('remote_confirm')) {
      this.confirmRemote(item, this.config.data.remote_confirm, 'addButton');
    } else {
      this.setUserInfo(item);
    }
  }

  confirmRemote(menudata, action, type?) {
    if (action.datasource != undefined && action.expression != undefined) {
      var apiObj: any = {};
      var datasource = JSON.parse(JSON.stringify(action.datasource));
      apiObj.resource = datasource.resource;
      apiObj.query_id = datasource.query_id != undefined ? datasource.query_id : 'GET_BY_ID';
      apiObj.application = datasource.application
      apiObj.args = datasource.args != undefined ? this.baseService.buildDyanamicStr(datasource.args, { data: menudata }) : '';
      apiObj.filter = datasource.filter != undefined ? this.baseService.buildDyanamicStr(datasource.filter, { data: menudata }) : '';
      if (this.appService.isFacilityAware()) {
        apiObj.args += ',facility_id:' + localStorage.getItem("setFacilityId")
      }
      this.loader.showSpinner();
      this.baseService.getByDataSource(apiObj).subscribe(
        (data: any) => {
          if (data.errCode == -1) {
            this.alerts.error(data.message);
          } else {
            if (data.resource != undefined && data.resource.length > 0) {
              var item = data.resource[0];
              console.log(item);
              if (eval(action.expression)) {
                if (type != undefined && type == 'addButton') {
                  this.setUserInfo(menudata);
                }
              } else {
                //added condition for dynamic alert
                if (action.msg_key && item[action.msg_key] != undefined && item[action.msg_key] != '') {
                  this.alerts.error(item[action.msg_key]);
                } else {
                  this.alerts.error(action.err_message || 'error');
                }
              }
            } else {
              this.alerts.error(action.err_message || 'error');
            }
          }
          this.loader.hideSpinner();
        }, error => {
          console.log(error);
          this.alerts.error('API error');
          this.loader.hideSpinner();
        }
      )
    } else {
      console.error("please define datasource");
    }
  }


  setUserInfo(item) {
    // this.dialog.close();
    this.hide()
    if (this.config.data.hasOwnProperty('conditions')) {
      let flag = true;
      this.config.data.conditions = this.appService.check_permssion_PRN(this.config.data.conditions, "check_prn")
      for (let condition of this.config.data.conditions) {
        if (eval(condition.expression)) {
          if (condition.action == 'remote_confirm') {
            this.alerts.error(condition.err_message);
            flag = false;
          } else {
            if (this.rolePermissionService.checkAccessPermission(condition.action.action_name, condition.action.resource, condition.action.application)||(condition.action.permission_required != undefined && condition.action.permission_required == false)) {
              flag = false;
              let size = this.baseService.getModalSize(condition.action['popup']['size'] ? condition.action['popup']['size'] : '');
              condition['action']['data'] = item;
              this.smartModalService.open(PopupFormComponent, condition.action, condition.action['popup']['title'], size).subscribe(
                response => {
                  this.dialog.close(response.result.resource[0]);
                  this.hide();
                }, err => { }
              );
              break;
            } else {
              flag = true;
            }
          }
        }
      }
      if (flag) {
        this.dialog.close(item);
        this.hide();
      }
    } else {
      this.dialog.close(item);
      this.hide();
    }
  }


  InputEvent(event) {
    this.dialog.close();
    this.hide()
    // this.dialog.close()
    let label = this.config.data.fixLabel;
    if (event != undefined && event.searchField != undefined && event.searchField.key != undefined) {
      label['searchField'] = event.searchField.key;
      label['searchText'] = event.searchText;
      label['facility_id'] = this.config?.data?.args?.facility_id
    }
    var size = this.baseService.getModalSize(label['popup']['size'] ? label['popup']['size'] : '');
    if (label.check_permission) {
      let _permission = this.appService.checkPermissionforPrn(label.check_permission, "pre_registration", "patient")
      for(let i = 0; i < _permission.length; i++) {
        let permission = this.rolePermissionService.checkAccessPermission(_permission[i].action_name, _permission[i].resource, label.application);
        if(label.permission_required != undefined && label.permission_required == false){
          label.resource = "patient";
          this.openPopUp(label, size);
          return false
        } else if (permission) {
          label.resource = _permission[i].resource;
          this.openPopUp(label, size);
          return false
        }
      }
    } else {
      this.openPopUp(label, size);
    }
  }

  closesOverlay() {
    console.log("close overlay");
  }

  openPopUp(label, size) {
    this.smartModalService.open(PopupFormComponent, label, label['popup']['title'], size).subscribe(
      response => {
        if(response.result!=undefined && response.result.resource!=undefined && response.result.resource.length!=undefined&& response.result.resource[0]!=undefined){
          this.smartModalService.sendResult(response.result.resource[0]);
          this.dialog.close(response.result.resource[0]);
        }
        this.hide()
      }, err => { }
    );
  }

  hide() {
    this.dialog.close()
  }

}
